import { Trans, useTranslation } from 'react-i18next';

import { AffiliateURL } from './AffiliateURL';

import { useAuth } from '@/contexts/AuthContext';

export function Affiliate() {
  const { user } = useAuth();

  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.Vtex.components.Affiliate',
  });

  return (
    <div className="space-y-4 rounded-lg bg-gray-100 p-4">
      <h3 className="mb-2 text-lg font-semibold">
        {t('title')}
        <span className="ml-1 inline-block text-sm font-light italic text-muted-foreground">
          {t('obsFreemium')}
        </span>
      </h3>

      <div className="space-y-2">
        <h4 className="mb-2 font-semibold">{t('createAffiliateList.title')}</h4>

        <ol className="list-inside list-decimal space-y-2 pl-4">
          <li>
            <Trans
              t={t}
              i18nKey="createAffiliateList.item1"
              components={{ strong: <strong /> }}
            />
          </li>
          <li>
            <Trans
              t={t}
              i18nKey="createAffiliateList.item2"
              components={{ strong: <strong /> }}
            />
          </li>
          <li>
            <Trans
              t={t}
              i18nKey="createAffiliateList.item3"
              components={{ strong: <strong /> }}
            />
          </li>
          <li>
            <Trans
              t={t}
              i18nKey="createAffiliateList.item4"
              components={{ strong: <strong /> }}
            />
          </li>
          <li>
            <Trans
              t={t}
              i18nKey="createAffiliateList.item5"
              components={{ strong: <strong /> }}
            />
          </li>
        </ol>
      </div>

      <div className="space-y-2">
        <h4 className="mb-2 font-semibold">{t('fillAffiliateList.title')}</h4>

        <ol className="list-inside list-decimal space-y-2 pl-4">
          <li>
            <Trans
              t={t}
              i18nKey="fillAffiliateList.item1"
              components={{ strong: <strong /> }}
            />
          </li>

          <li>
            <Trans
              t={t}
              i18nKey="fillAffiliateList.item2"
              components={{ strong: <strong /> }}
            />{' '}
            {user?.customer.vtexAffiliateId}
          </li>

          <li>
            <Trans
              t={t}
              i18nKey="fillAffiliateList.item3"
              components={{ strong: <strong /> }}
            />{' '}
            {user?.customer.vtexSalesChannel}
          </li>

          <li>
            <Trans
              t={t}
              i18nKey="fillAffiliateList.item4"
              components={{ strong: <strong /> }}
            />{' '}
            vtex@generativecrm.com
          </li>

          <li>
            <AffiliateURL />
          </li>

          <li>
            <Trans
              t={t}
              i18nKey="fillAffiliateList.item5"
              components={{ strong: <strong /> }}
            />
          </li>

          <li>
            <Trans
              t={t}
              i18nKey="fillAffiliateList.item6"
              components={{ strong: <strong /> }}
            />
          </li>
        </ol>
      </div>

      <p className="mt-4 text-sm text-muted-foreground">{t('note')}</p>
    </div>
  );
}
